var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "categoryItemContent container" },
    [
      _c("promotion-slider", { attrs: { "slides-per-view": 3 } }),
      _c("div", { staticClass: "section-listGame__header" }, [
        _c("div", { staticClass: "title" }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.categoryImage,
                expression: "categoryImage"
              }
            ],
            attrs: { src: _vm.categoryImage, alt: _vm.categoryTitle }
          }),
          _c("div", { staticClass: "title__text" }, [
            _c("h2", [_vm._v(_vm._s(_vm.categoryTitle))]),
            _c("p", [_vm._v(_vm._s(_vm.categoryDescription))])
          ])
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showAllGamesMode && _vm.totalGamesCount,
                expression: "!showAllGamesMode && totalGamesCount"
              }
            ],
            staticClass: "link"
          },
          [
            _c("router-link", { attrs: { to: _vm.allGamesUrl } }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("front.game.button.see_all")) +
                    " " +
                    _vm._s(_vm.totalGamesCount)
                )
              ]),
              _c(
                "svg",
                {
                  attrs: {
                    width: "7",
                    height: "12",
                    viewBox: "0 0 7 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: { d: "M1 11L6 6L1 1", stroke: "#926D20" }
                  })
                ]
              )
            ])
          ],
          1
        )
      ]),
      _c("catalog-bar-with-provider-filter", {
        key: _vm.$route.path,
        attrs: {
          "sort-options": _vm.sortOptions,
          "vendor-platform-ids": _vm.vendorPlatformIds
        },
        on: {
          sortOptionChanged: _vm.sortGames,
          platformFilterChanged: _vm.filterGames
        }
      }),
      _vm.sortedCategoryGames.length
        ? _c(
            "div",
            [
              _vm.winnerListEnabled
                ? _c("games-block-with-winners-list", {
                    attrs: { items: _vm.blockWithWinnersGames }
                  })
                : _c("games-block-simple", {
                    attrs: { items: _vm.blockWithWinnersGames }
                  }),
              _vm._l(_vm.cycleComponents, function(component, index) {
                return _c(component, {
                  key: index,
                  tag: "component",
                  staticClass: "sectionGameList",
                  attrs: { items: _vm.getComponentItems(index) }
                })
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showAllGamesMode && _vm.hasMoreGames,
                      expression: "!showAllGamesMode && hasMoreGames"
                    }
                  ],
                  staticClass: "btn-loadCatalog",
                  on: {
                    click: function($event) {
                      return _vm.showMoreGames()
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("front.game.button.load_more")))
                  ])
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading && !_vm.sortedCategoryGames.length,
              expression: "!loading && !sortedCategoryGames.length"
            }
          ],
          staticClass: "text-center mt-5 mb-4"
        },
        [
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("front.game.info.no_one_game_found")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }